import { ISetNameParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class RenameWorkbookRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('renameWorkbook', {
      id: id,
      name: name
    });
  }
}
